import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ColorUtil } from 'src/app/shared/util/color-util';

@Component({
  selector: 'app-analysis-header-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalysisHeaderTabComponent implements OnInit {
  @Input() active: boolean;
  @Input() color: string;
  @Output() selected = new EventEmitter();

  @HostBinding('class.gmr-4') margin = true;

  get boxShadow() {
    return `0px 4px 10px ${this.shadow}`;
  }

  private shadow = 'rgba(78, 95, 124, 0.16)';

  ngOnInit() {
    if (this.color) {
      this.shadow = ColorUtil.hexToRGBA(this.color, 0.2);
    }
  }

  tabClicked() {
    this.selected.emit();
  }
}
